import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmittedFormListService } from '../submitted-form-list/submitted-forms-list.service';
import * as _ from "lodash";

@Component({
  selector: 'app-assign-users-to-hazard',
  templateUrl: './assign-users-to-hazard.component.html',
  styleUrls: ['./assign-users-to-hazard.component.scss']
})
export class AssignUsersToHazardComponent implements OnInit {

  @Input() public selectedUsers: Array<any> = [];
  @Input() public usersList;
  @Input() public formId;
  @Input() public description;

  dropdownSettings = {
    singleSelection: false,
    idField: "_id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableCheckAll: true,
    allowSearchFilter: true
  };

  constructor(
    public activeModal: NgbActiveModal,
    private _submittedFormListService: SubmittedFormListService,
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  assignUsers() {
    let users = {};
    _.forEach(this.selectedUsers, (user) => {
      users[user._id] = user['name'];
    })
    this._submittedFormListService.assignHazardToUser(this.formId, { hAssignedTo: users }).subscribe((response: any) => {
      if (response['success']) {
        this.activeModal.close({
          success: true,
          usersList: users
        });
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/assign-users-to-hazard/assign-users-to-hazard.component.ts